export const SALES_STAGES = [
  { value: 0, name: "Pipeline Generation", subtitle: "Prospecting" },
  { value: 1, name: "Discovery & Qualification", subtitle: "Identify the Pain" },
  { value: 2, name: "Stakeholder Alignment", subtitle: "Define the Value" },
  { value: 3, name: "Sponsorship", subtitle: "Validate the Value" },
  { value: 4, name: "Technical Validation", subtitle: "Measure the Value" },
  { value: 5, name: "Negotiation", subtitle: "Final Structure & Terms" },
  { value: 6, name: "Close", subtitle: "Deployment" },
];
